<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-input v-model="keyword" placeholder="合同号" style="width: 200px" size="small" clearable></el-input>
        <el-input v-model="keyword2" placeholder="伞型" style="width: 200px;margin-left: 5px;" size="small" clearable></el-input>
        <el-input v-model="keyword3" placeholder="产品规格" style="width: 200px;margin-left: 5px;" size="small" clearable></el-input>
        <el-input v-model="keyword4" placeholder="名称" style="width: 200px;margin-left: 5px;" size="small" clearable></el-input>
        <el-button type="primary" size="small" style="margin-left: 10px" @click="search"><i class="el-icon-search" style="margin-right: 5px"></i>搜索</el-button>
        <el-button size="small" @click="reset"><i class="el-icon-refresh-left" style="margin-right: 5px"></i>重置</el-button>
        <div style="margin-top: 10px;">
          <el-date-picker v-model="today" type="date" placeholder="选择日期" @change="search"
            :clearable="false" :editable="false"></el-date-picker>
        </div>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="add"><i class="el-icon-plus" style="margin-right: 5px"></i>新增</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="calc(100% - 72px)" style="width: 100%">
          <el-table-column align="center" label="日期" min-width="100" prop="riqi"></el-table-column>
          <el-table-column align="center" label="客户" min-width="100" prop="kehu"></el-table-column>
          <el-table-column align="center" label="合同号" min-width="100" prop="hetonghao"></el-table-column>
          <el-table-column align="center" label="伞型" min-width="100" prop="sanxing"></el-table-column>
          <el-table-column align="center" label="产品规格" min-width="100" prop="chanpinguige"></el-table-column>
          <el-table-column align="center" label="合同数量" min-width="100" prop="hetongshuliang"></el-table-column>
          <el-table-column align="center" label="名称" min-width="100" prop="mingcheng"></el-table-column>
          <el-table-column align="center" label="规格" min-width="100" prop="guige"></el-table-column>
          <el-table-column align="center" label="单伞用量" min-width="100" prop="dansanyongliang"></el-table-column>
          <el-table-column align="center" label="工序" min-width="100" prop="gongxu"></el-table-column>
          <el-table-column align="center" label="当日外协/库存" min-width="150" prop="kucun"></el-table-column>
          <el-table-column align="center" label="产量" min-width="100" prop="chanliang"></el-table-column>
          <el-table-column align="center" label="执行单价" min-width="100" prop="zhixingdanjia"></el-table-column>
          <el-table-column align="center" label="成控单价" min-width="100" prop="chengkongdanjia"></el-table-column>
          <el-table-column align="center" label="期初金额" min-width="100" prop="qichujine"></el-table-column>
          <el-table-column align="center" label="期初外协/库存" min-width="100" prop="qichukucun"></el-table-column>
          <el-table-column align="center" label="期初产量" min-width="100" prop="qichuchanliang"></el-table-column>
          
          <el-table-column align="center" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
              <el-button type="text" @click="del(scope.row.id)" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px; text-align: center">
          <el-pagination
            background
            layout="total, sizes,prev, pager, next, jumper"
            @size-change="pageSizeChange"
            :total="total"
            @current-change="pageChange"
            :current-page="pageNum"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加修改弹窗 -->
    <el-dialog title="编辑" :visible.sync="editModal">
      <el-form :model="editForm" ref="EditForm" label-width="150px" :rules="rules">
        <el-form-item label="日期" prop="riqi">
          <el-date-picker v-model="editForm.riqi" value-format="timestamp"
            type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="客户" prop="kehu">
          <el-input v-model="editForm.kehu"></el-input>
        </el-form-item>
        <el-form-item label="合同号" prop="hetonghao">
          <el-select v-model="orderValue" filterable placeholder="请选择"
            @change="orderChange" style="width: 600px;">
            <el-option v-for="item in orderSelectList"
              :key="item.hetonghao+'_'+item.sanxing+'_'+item.chanpinguige+'_'+item.mingcheng+'_'+item.guige+'_'+item.hetongshuliang"
              :label="item.hetonghao+'_'+item.sanxing+'_'+item.chanpinguige+'_'+item.mingcheng+'_'+item.guige+'_'+item.hetongshuliang"
              :value="item.hetonghao+'_'+item.sanxing+'_'+item.chanpinguige+'_'+item.mingcheng+'_'+item.guige+'_'+item.hetongshuliang">
            </el-option>
          </el-select>
          <el-input v-model="editForm.hetonghao" style="margin-right: 10px;"></el-input>
        </el-form-item>
        <el-form-item label="伞型" prop="sanxing">
          <el-input v-model="editForm.sanxing"></el-input>
        </el-form-item>
        <el-form-item label="产品规格" prop="chanpinguige">
          <el-input v-model="editForm.chanpinguige"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="mingcheng">
          <el-input v-model="editForm.mingcheng"></el-input>
        </el-form-item>
        <el-form-item label="规格" prop="guige">
          <el-input v-model="editForm.guige"></el-input>
        </el-form-item>
        <el-form-item label="合同数量" prop="hetongshuliang">
          <el-input-number v-model="editForm.hetongshuliang" :precision="4" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="工序" prop="gongxu">
          <div style="display: flex;">
            <el-input v-model="editForm.gongxu" style="margin-right: 10px;"></el-input>
            <el-select v-model="gongxuValue" filterable placeholder="请选择" style="width: 400px;"
              @change="gongxuChange" >
              <el-option v-for="(item,index) in gongxuSelectList"
                :key="index" :label="item.gongxu" 
                :value="item.gongxu">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="单伞用量" prop="dansanyongliang">
          <el-input-number v-model="editForm.dansanyongliang" :precision="0" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="当日外协/库存" prop="kucun">
          <el-input-number v-model="editForm.kucun" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="当日产量" prop="chanliang">
          <el-input-number v-model="editForm.chanliang" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="执行单价" prop="zhixingdanjia">
          <el-input-number v-model="editForm.zhixingdanjia" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="成控单价" prop="chengkongdanjia">
          <el-input-number v-model="editForm.chengkongdanjia" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="期初金额" prop="qichujine">
          <el-input-number v-model="editForm.qichujine" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="期初外协/库存" prop="qichukucun">
          <el-input-number v-model="editForm.qichukucun" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="期初产量" prop="qichuchanliang">
          <el-input-number v-model="editForm.qichuchanliang" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editModal = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
const editFormData = () => {
  return {
    riqi: '',
    kehu: "",
    hetonghao: "",
    sanxing: "",
    chanpinguige: "",
    mingcheng: "",
    guige: "",
    hetongshuliang: 0,
    gongxu: "",
    dansanyongliang: 0,
    kucun: 0,
    chanliang: 0,
    zhixingdanjia: 0,
    chengkongdanjia: 0,
    qichujine: 0,
    qichukucun: 0,
    qichuchanliang: 0,
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keyword2: "",
      keyword3: "",
      keyword4: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
      orderSelectList: [],
      memberSelectList: [],
      gongxuSelectList: [],
      orderValue: '',
      gongxuValue: '',
      today: '',
    }
  },

  created() {
    this.sf = localStorage.sf
    this.getList()
    this.getSelectList()
  },

  methods: {
    orderChange(e) {
      let arr = e.split('_')
      for(let i in this.orderSelectList) {
        if(this.orderSelectList[i].hetonghao==arr[0]&&this.orderSelectList[i].sanxing==arr[1]
          &&this.orderSelectList[i].chanpinguige==arr[2]&&this.orderSelectList[i].mingcheng==arr[3]
          &&this.orderSelectList[i].guige==arr[4]&&this.orderSelectList[i].hetongshuliang==arr[5]) {
          this.editForm.kehu = this.orderSelectList[i].kehu
          this.editForm.hetonghao = this.orderSelectList[i].hetonghao
          this.editForm.sanxing = this.orderSelectList[i].sanxing
          this.editForm.chanpinguige = this.orderSelectList[i].chanpinguige
          this.editForm.mingcheng = this.orderSelectList[i].mingcheng
          this.editForm.guige = this.orderSelectList[i].guige
          this.editForm.hetongshuliang = this.orderSelectList[i].hetongshuliang
          
          this.editForm.gongxu = ''
          this.gongxuValue = ''
          this.editForm.dansanyongliang = 0
          this.editForm.zhixingdanjia = 0
          this.editForm.chengkongdanjia = 0
          
          if(this.orderSelectList[i].gongxuArr) {
            this.gongxuSelectList = JSON.parse(this.orderSelectList[i].gongxuArr)
          }else{
            this.gongxuSelectList = []
          }
        }
      }
    },
    
    gongxuChange(e) {
      for(let i in this.gongxuSelectList) {
        if(this.gongxuSelectList[i].gongxu==e) {
          this.editForm.gongxu = this.gongxuSelectList[i].gongxu
          this.editForm.dansanyongliang = this.gongxuSelectList[i].dansanyongliang
          this.editForm.zhixingdanjia = this.gongxuSelectList[i].zhixingdanjia
          this.editForm.chengkongdanjia = this.gongxuSelectList[i].chengkongdanjia
        }
      }
    },
    
    getSelectList() {
      this.$request.post('/index.php/admin/ordermodel/chengxingMbSelect').then((res) => {
        this.orderSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    getMemberSelectList() {
      this.$request.post('/index.php/admin/admin/memberSelect').then((res) => {
        this.memberSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.keyword2 = ""
      this.keyword3 = ""
      this.keyword4 = ""
      this.today = ''
      this.search()
    },
    
    add() {
      let form = JSON.parse(JSON.stringify(this.editForm))
      this.editForm = JSON.parse(JSON.stringify(editFormData()))
      if(form.hetonghao) {
        this.editForm.kehu = form.kehu
        this.editForm.hetonghao = form.hetonghao
        this.editForm.sanxing = form.sanxing
        this.editForm.chanpinguige = form.chanpinguige
        this.editForm.mingcheng = form.mingcheng
        this.editForm.guige = form.guige
        this.editForm.hetongshuliang = form.hetongshuliang
      }
      if(form.gongxu) {
        this.editForm.gongxu = form.gongxu
        this.editForm.dansanyongliang = form.dansanyongliang
        this.editForm.zhixingdanjia = form.zhixingdanjia
        this.editForm.chengkongdanjia = form.chengkongdanjia
      }
      
      this.editModal = true
    },

    edit(id) {
      this.$request.post('/index.php/admin/orderform/chengxingInfo', {id: id}).then((res) => {
        this.editForm = res.data.data
        this.editForm.riqi = parseInt(this.editForm.riqi*1000)
        this.editModal = true
      }).catch(err => {
        console.log(err)
      })
    },

    del(id) {
      this.$confirm("请确认是否删除该条信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request.post('/index.php/admin/orderform/chengxingDel', {id: id}).then((res) => {
          this.$message.success(res.data.msg)
          this.getList()
        }).catch(err => {
          console.log(err)
        })
      })
    },

    save() {
      this.$refs["EditForm"].validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.editForm))
          data.riqi = parseInt(data.riqi/1000)
          data.account = localStorage.account
          this.$request.post('/index.php/admin/orderform/chengxingSave', data).then((res) => {
            if(res.data.code==200) {
              this.$message.success(res.data.msg)
              this.editModal = false
              this.getList()
            }else{
              this.$message.error(res.data.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },


    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        page: this.pageNum,
        num: this.pageSize,
      }
      if(this.keyword) {
        data.keyword = this.keyword
      }
      if(this.keyword2) {
        data.keyword2 = this.keyword2
      }
      if(this.keyword3) {
        data.keyword3 = this.keyword3
      }
      if(this.keyword4) {
        data.keyword4 = this.keyword4
      }
      if(this.today) {
        data.year = this.today.getFullYear()
        data.month = this.today.getMonth()+1
        data.day = this.today.getDate()
      }
      this.$request.post('/index.php/admin/orderform/chengxingList', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
